const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWingLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KRILO-lijevo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M300.74,152.19c10.35-1.65,23.48,11,25.56,23.91,3.58,22.27-26.54,39.6-38.09,41.23a14.53,14.53,0,0,1-5.57-.19c-8.93-2.11-13.1-12.4-14.18-15.29,6.15-19.42,14.57-32.46,20.62-40.31C293.7,155.53,296.72,152.83,300.74,152.19Z",
    style: {
      fill: "#ffea00",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5,219.6c12.7,1.2,38.3-19.2,38.8-18.8,32.6,30.1-44.2,63.9-44.9,49.4,1.4-3.8-7.8-16-11.7-19.7C270.6,231.5,279.5,227.6,283.5,219.6Z",
    style: {
      fill: "#ffea00",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,250.2c11.3,4,34.7-4.6,34.9-4.1,10.9,28.8-38.5,37.1-58.2,26.2-1.5-.8-.8-6.9-2.3-8.5C255.3,262.6,271.5,260.8,275.9,250.2Z",
    style: {
      fill: "#fff400",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,279c6.4.6,27.8,3.1,27.8,5.1.1,21.2-39.9,31.3-53.6,16C220.4,295.6,223.4,273.1,250.9,279Z",
    style: {
      fill: "#fff400",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,181.14c4.34-2.56,10.15-14.7,15-15.9,10.09-2.43,14,15.15,13.58,21.4-2.3,17.61-31.1,36.53-26.94,30.25.44-.71-.41-10.16-2.57-11.76s7-7.64,6.9-13.95C283.84,185.11,277.58,181.12,277,181.14Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.8,224.6c10.9.9,32.8-14.8,33.2-14.5,27.9,23.2-37.8,49.3-38.4,38.1,1.2-3-6.7-12.3-10-15.2C254.8,233.8,262.4,230.8,265.8,224.6Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,251c8.3,2.8,25.3-3.3,25.5-2.9,7.9,20.4-28.1,26.2-42.4,18.5-1.1-.6-.6-4.9-1.7-6C251.5,259.8,263.3,258.6,266.5,251Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,286.7c7.6,1.7,21.6-6.1,21.8-5.7,1.4,2.81,2.37,6.08,1.62,8.76C263.47,300,245,306,232.6,300.79a22.1,22.1,0,0,1-4.7-2.69C231,296.8,241.1,294.3,242.9,286.7Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6,302.4c1,.84,24.33,19.18,43.4,9.8,2.16-1.06,15-7.74,13.93-18.1-.62-6.16-5.93-11.65-13.33-14.33.16,3.35,0,11.5-5.45,18.08C260.24,307.32,244.26,309.77,229.6,302.4Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,301c-3.8,9.7-19.1,11.89-27.14,11.67a39.82,39.82,0,0,1-19.39-5.85l-6.86-4.37c18.1,10.25,36.74,8.36,43,.37,1.36-1.74,6.59-9.48,6.11-18.67-.09-1.77-.38-3.19-.12-3.25C279.34,280.65,286.4,292.25,283,301Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,243c16.6,20.6-9.1,54.4-51.3,36.7-3.4-7.3.8-13.8,1-11.9,19.4,10.5,39.1,4,42.1-7.8C307.9,245.4,303.3,245.9,312,243Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,196.8c11,5.3,10,32.6-5.5,45.7-8.7,7.3-40.6,11.9-45.7,9.6.3-1.1-3.2-4.7-1-5.7,3.7-1.7,56.8-4.1,42.4-44.9C315.5,198,323.1,193.4,326.6,196.8Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.8,153.7c10.6-14.1,30.3-14.3,35.6-2,7.4,18,5.4,30-1.6,40.2-8.8,16.7-56.7,34-55.1,30,17.8-13.5,44.3-20.7,44.5-43.1C320.3,152.6,304.8,148.9,296.8,153.7Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6,248.3c3.4,19.2-10.3,46-54.9,26.6-3.3-8.3-8.2-9.9-8-7.8,21.4,13.3,49.9,9,54.2-3.5C311.6,248.3,304.3,250.5,314.6,248.3Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7,204.2c2.7,5.6,3.7,7.6,2.8,19.7-1.8,5.5-6.1,11.6-14.9,18.5-8.7,6.5-35.7,10.1-40.7,8,.3-.9-2-2.9.2-3.8,4.2-.2,58-3.3,45.6-38.3C318.8,201.4,325.8,200.4,327.7,204.2Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.4,151.5c9.2-9.7,23.4-3.9,26,1.4,8.2,16.7,4.5,28.4-1.6,38.3-9.4,15.1-49.8,32.8-47.4,29.5,17.4-13,45.4-19,44.9-40.7C324.4,154.7,309.3,146.9,302.4,151.5Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,159.8c-5-5-7.2-11.3-1.7-13.7,2.1-.4,5.7.8,9.6,9.7,3.3,7.4,3.3,15.6,2.6,18C327.2,193.9,331.5,169.4,321.9,159.8Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,222.1c-.4-5.4,1.4-10.4,5.4-9.4,1.3.7,2.7,3.2.7,10.5-1.7,6.2-5.5,11.3-7,12.6C311.6,246,325.3,232.5,324.6,222.1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8,266.1c1-3.9,3.4-6.9,6-5.3.7.8,1.1,2.8-2,7.5a21.76,21.76,0,0,1-7.8,7.1C292.1,279.7,304.8,273.5,306.8,266.1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.1,262.21c-13.7,11.2-15,27.2-9.3,37.2,13.2,23,35.8,8.1,32.2-4.9,16.3,6,26.1-10.2,16.8-25.1,12.1,5.6,33.6-19.1,12.9-33.9.7,1.5,10.3-2,13.5-9.3,2.1-4.7,1.6-10.9-5.5-18.3,3.5,1.1,19.6-18.7.5-26.5-10.9-4.4-32.4,14.8-35.5,30-6,23.4-2.4,28.8-11.9,39A124.54,124.54,0,0,1,216.1,262.21Z",
    style: {
      fill: "#cc200a",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.3,269.41c-13.7,10.8-7.6,17.5-8.1,27.1,13.2,22.1,31.8,7.4,28.3-5.1,16.3,5.7,26.1-9.8,16.8-24.2,12.1,5.4,33.6-18.4,12.9-32.7.7,1.5,10.3-1.9,13.5-9,2.1-4.5,1.6-10.5-5.5-17.7,3.5,1.1,19.6-18,.5-25.5-10.9-4.3-19.9,13.9-24.6,27.8-6,22.5-3.7,34.4-13.2,44.2C232.9,257.51,221.7,264.61,215.3,269.41Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,266.61c-11.7,9.8-10.8,11.7-11.2,20.4,11.3,20,30.5,8.3,27.5-3,14,5.2,22.4-8.9,14.4-21.9,10.4,4.9,28.8-16.7,11.1-29.6.6,1.3,8.8-1.8,11.6-8.1,1.8-4.1,1.3-9.5-4.8-16,3,1,20.1-15.7,3.7-22.5-9.3-3.9-14.7,5.6-19.7,14.3-10.1,17.5-6.2,42.7-14.3,51.6C232.1,258.61,223.9,262.31,218.4,266.61Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingLeft);
export default __webpack_public_path__ + "static/media/wing-left.258029169e1c39007d33654aa3e560e9.svg";
export { ForwardRef as ReactComponent };